import React from 'react';
import { PulseLoader } from 'halogenium';

const Spinner = () => <PulseLoader color="#666" size="12px" margin="2px" />;

export default Spinner;
